import { styled } from "@mui/material";

export const StyledText = styled('div')<{
  color?: string;
  fontWeight?: 'normal' | 'bold' | 'light';
  textAlign?: 'left' | 'center' | 'right';
}>(({ theme, color, fontWeight, textAlign }) => ({
  color: color || theme.palette.text.primary,
  fontWeight: fontWeight === 'bold' ? 'bold' :
              fontWeight === 'light' ? '300' : 'normal',
  textAlign: textAlign || 'left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',

  '&.empty': {
    color: theme.palette.text.disabled,
    fontStyle: 'italic',
  }
}));
